import { useState } from 'react';

import { FormWithReferenceViewModal } from '../FormWithReferenceViewModal/FormWithReferenceViewModal.tsx';
import { ObjectiveEditForm } from './ObjectiveEditForm.tsx';
import { INVALID_FORM_WARNING } from './constants.ts';

type ObjectiveEditModalProps = {
  activeId: string;
  onModalClose: () => void;
  isModalOpen: boolean;
  setActiveId: (id: string) => void;
  compSequence: string[];
};
export function ObjectiveEditModal({
  activeId,
  isModalOpen,
  onModalClose,
  setActiveId,
  compSequence,
}: ObjectiveEditModalProps) {
  const [formValid, setFormValid] = useState(false);

  return (
    <FormWithReferenceViewModal
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      compSequence={compSequence}
      activeId={activeId}
      setActiveId={setActiveId}
      formValid={formValid}
      invalidFormWarning={INVALID_FORM_WARNING}
    >
      <ObjectiveEditForm
        key={activeId} // make sure we properly reset the form every time we switch to a different property
        activeId={activeId}
        handleFormValidChange={setFormValid}
      />
    </FormWithReferenceViewModal>
  );
}
